import React, { useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import portfolio1 from '../static/img/portfolio1.jpg';
import portfolio2 from '../static/img/portfolio2.jpg';
import portfolio3 from '../static/img/portfolio3.jpg';
import portfolio4 from '../static/img/portfolio4.jpg';
import portfolio5 from '../static/img/portfolio5.jpg';
import portfolio6 from '../static/img/portfolio6-2.png';
import portfolio7 from '../static/img/portfolio7.png';
import portfolio8 from '../static/img/portfolio8.png';
import portfolio9 from '../static/img/portfolio9.png';
import portfolio10 from '../static/img/portfolio10.png';
import portfolio11 from '../static/img/portfolio11.png';
import portfolio12 from '../static/img/portfolio12.png';
import Grid from '@material-ui/core/Grid';
import PortfolioModal from '../components/PortfolioModal';
const color = { react: '#61dbfb', js: '#f0db4f', aws: '#000', python: '#6281b6' };
const demosJa = [
	{
		title: 'データのビジュアライズ化',
		detail: 'e-Stat(日本の統計データを扱うWebサイト)のデータをAPIで取得しグラフを作成',
		chips: [ 'React', 'ChartJs' ],
		link: 'blog',
		img: portfolio2,
		color: color['react']
	},
	{
		title: 'データのビジュアライズ化',
		detail: '新型コロナウイルスのデータをAPIで取得、ChartJsでグラフ作成。世界合計を線グラフ、各国を棒グラフ、日本については地図で分布図も作成。',
		chips: [ 'React', 'ChartJs', 'Google Chart' ],
		link: 'covid',
		img: portfolio3,
		color: color['react']
	},
	{
		title: 'データのビジュアライズ化',
		detail: '仮想通貨の値動きについてAPIでデータを取得、ChartJsでグラフ作成。ページ遷移しても追加したコインリストを維持。',
		chips: [ 'React', 'ChartJs' ],
		link: 'coins',
		img: portfolio4,
		color: color['react']
	},
	{
		title: '写真をAPIで取得し表示',
		detail: 'キーワードに基づき、pixabayサイトからAPIでデータを取得し表示。',
		chips: [ 'React' ],
		link: 'pixabay',
		img: portfolio5,
		color: color['react']
	},
	{
		title: '映画をAPIで取得し表示',
		detail: 'キーワードに基づき映画を検索し表示。見たい映画をWatchListに、見た映画をWatchedListに追加、移動、削除が可能。',
		chips: [ 'React' ],
		link: 'movieSearch',
		img: portfolio1,
		color: color['react']
	},
	{
		title: '文章自動作成',
		detail: 'マルコフ連鎖により文章を作成。(英語はゲームメタルギアソリッドのセリフ、日本語はメタルギアソリッドと走れメロスから独自の文章を作成。)',
		chips: [ 'Django' ],
		link: 'screennshot_chatbot',
		img: portfolio7,
		color: color['python']
	},
	{
		title: '文章から熟語を探し出し、意味調べ(開発中)',
		detail:
			'SNSのように成果物を共有、他人が作成した単語カードにチャレンジ、成果物をコピーしそのまま編集することなどが可能。スクレイピングでニュースサイトから得たデータをもとにニュースを表示したり、外国語検索で辞書にない単語の意味を取得可能。2人で開発。',
		chips: [ 'Django', 'React', 'Django REST Framework', 'Web Scrape' ],
		link: 'screennshot_detectIdiom',
		img: portfolio6,
		color: color['python']
	},
	{
		title: '画像のスタイル変換(開発中)',
		detail: 'ユーザーがアップロードした写真を様々なスタイルを加えて芸術アートに変身。スタイルを加える強度などを変更可能。クラウド(AWS)かクライアント側で実行選択可。2人で開発。',
		chips: [ 'Django', 'React', 'Django REST Framework', 'AWS' ],
		link: 'screennshot_styleAi',
		img: portfolio8,
		color: color['python']
	},
	{
		title: 'オンラインショップ',
		detail: 'AWS Amplify, Cognito, DynamoDBを使って簡単なオンラインショップを作成してみました。Stripeで支払い処理もできます。管理者のみ本の追加可能です。',
		chips: [ 'React', ' GraphQL', 'AWS', 'Stripe' ],
		link: 'screennshot_annazon',
		img: portfolio9,
		color: color['aws']
	},
	{
		title: '大阪の城と城跡マップ',
		detail: '大阪の城と城跡にマーカをつけました。マーカーをクリックするとその詳細を確認できます。',
		chips: [ 'React', ' leaflet' ],
		link: 'leaflet',
		img: portfolio10,
		color: color['react']
	},
	{
		title: 'テスト問題演習',
		detail: 'PDFからPythonでデータ抽出し、問題を出題、選択肢を選び正解を確認する。解答後の必要な問題だけの確認（レビュー）も可能。',
		chips: [ 'React', ' Python' ],
		link: 'securityPlus',
		img: portfolio11,
		color: color['react']
	},
	{
		title: '英単語暗記用',
		detail: '毎日覚えたい単語に触れることが大切なので、楽しみながら短時間で復習できるよう、音楽再生、単語切り替えスピードの調整を取り入れた。',
		chips: [ 'React' ],
		link: 'encard',
		img: portfolio12,
		color: color['react']
	}
];
const demosEn = [
	{
		title: 'Data Visualization',
		detail: 'Get e-Stat (website that handles Japanese statistical data) data with API and create a graph',
		chips: [ 'React', 'ChartJs' ],
		link: 'blog',
		img: portfolio2,
		color: color['react']
	},
	{
		title: 'Data Visualization',
		detail: 'Acquire data of new coronavirus with API and create graph with ChartJs. Line charts for the world total, bar charts for each country, and distribution maps for Japan are also created.',
		chips: [ 'React', 'ChartJs', 'Google Chart' ],
		link: 'covid',
		img: portfolio3,
		color: color['react']
	},
	{
		title: 'Data Visualization',
		detail: 'Get data about price movements of virtual currency with API and create graph with ChartJs.',
		chips: [ 'React', 'ChartJs' ],
		link: 'coins',
		img: portfolio4,
		color: color['react']
	},
	{
		title: 'Fetch and display photos using API',
		detail: 'Based on the keyword, data is acquired from the pixabay site using the API.',
		chips: [ 'React' ],
		link: 'pixabay',
		img: portfolio5,
		color: color['react']
	},
	{
		title: 'Fetch and display movies using API',
		detail: 'Search and display movies based on keywords. You can add, move, or delete the movies from the WatchList and the WatchedList.',
		chips: [ 'React' ],
		link: 'movieSearch',
		img: portfolio1,
		color: color['react']
	},
	{
		title: 'Chatbot with dynamically generated sentences',
		detail: 'Create sentences using the Markov chain algorithm. (English and Japanese quotes are dynamically generated using quotes from "Metal Gear Solid" and "Run, Melos!")',
		chips: [ 'Django' ],
		link: 'screennshot_chatbot',
		img: portfolio7,
		color: color['python']
	},
	{
		title: 'Look up words, idioms, and phrases to find the meaning',
		detail:
			"You can share articles that you studied like SNS, challenge word cards created by others, copy articles and edit them. You can display the news based on the data obtained from the news site by web scraping using beautiful soup. This app's word dictionary also uses web scraping to extend local word dictionary.",
		chips: [ 'Django', 'React', 'Django REST Framework', 'Web Scrape' ],
		link: 'screennshot_detectIdiom',
		img: portfolio6,
		color: color['python']
	},
	{
		title: 'Image and video style conversion',
		detail: 'Transform user uploaded photos into art by adding various styles. You can change the style strength to tune output. Processing can be selected server side or client side. Uses AWS as backend (EC2, S3, SQS)',
		chips: [ 'Django', 'React', 'Django REST Framework', 'AWS' ],
		link: 'screennshot_styleAi',
		img: portfolio8,
		color: color['python']
	},
	{
		title: 'Online book shop',
		detail: 'Online shop using AWS Amplify, Cognito and DynamoDB. Stripe handles payment transactions. Only Admins can add new books.',
		chips: [ 'React', ' GraphQL', 'AWS', 'Stripe' ],
		link: 'screennshot_annazon',
		img: portfolio9,
		color: color['aws']
	},
	{
		title: 'Castles Map in Osaka',
		detail: 'You can see all castles in Osaka and the details when you click the marker.',
		chips: [ 'React', ' leaflet' ],
		link: 'leaflet',
		img: portfolio10,
		color: color['react']
	},
	{
		title: 'Practice test',
		detail: 'I extracted data from PDF with Python and made question app. You can review any questions you want.',
		chips: [ 'React', ' Python' ],
		link: 'securityPlus',
		img: portfolio11,
		color: color['react']
	},
	{
		title: 'To learn English vocabularies',
		detail: "It's important to learn vocabularies everyday so I made this to have fun as much as I can.",
		chips: [ 'React' ],
		link: 'encard',
		img: portfolio12,
		color: color['react']
	}
];

const sectionTitle = { en: 'Portfolio', ja: '開発実績' };
const App = ({ language }) => {
	const [ demos, setDemos ] = useState([]);
	useEffect(
		() => {
			language === 'English' ? setDemos(demosEn) : setDemos(demosJa);
		},
		[ language ]
	);
	return (
		<div>
			<h1 className="mt-0 text-center sectionTitle">
				{language === 'English' ? sectionTitle.en : sectionTitle.ja}
			</h1>
			<Grid container spacing={2} className="w-100 mt-5 pb-5">
				{demos.map((demo, i) => {
					return (
						<Grid item xs={12} sm={6} md={3} key={i}>
							<Card style={{ borderTop: `3px solid ${demo.color}`, width: '100%', minWidth: '200px' }}>
								<Typography
									gutterBottom
									variant="h5"
									component="h2"
									className="p-3"
									style={{ height: '50px' }}
								>
									{demo.title}
								</Typography>
								<CardMedia style={{ height: '140px' }} image={demo.img} />
								<CardContent>
									<Typography
										variant="h5"
										color="textSecondary"
										component="p"
										className="portfolioDetail"
									>
										{demo.detail}
									</Typography>
								</CardContent>

								<div className="px-2 mt-2">{demo.chips.map((chip, j) => <Chip size="small" label={chip} key={j} className="mx-1"/>)}</div>
								<div className="text-right p-2">
									{demo.link.split('_')[0] !== 'screennshot' ? (
										<Button size="small" target="_blank" href={`/${demo.link}`} color="secondary">
											Demo
										</Button>
									) : (
										<><Button size="small" target="_blank" href="https://github.com/anzunba" color="secondary" className="mr-2 d-inline">Github</Button><PortfolioModal imgTitle={demo.link.split('_')[1]}/></>
									)}
								</div>
							</Card>
						</Grid>
					);
				})}
			</Grid>
		</div>
	);
};
export default App;
